import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import { Table } from "../../../components/Table/Table";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../../assets/img";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { checkPermission } from "../../redux/api/PermissionManager";

const RoomCategories = () => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [amenity, setAmenity] = useState();
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState(false);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();

  // ✅ Toggle status
  const handleStatus = async ({ id, status }) => {
    setLoading(true);
    const formdata = new FormData();
    // formdata.append("type", 10);
    formdata.append("status", !status);

    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetchCategories(page);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error updating status:", error);
      setLoading(false);
      toast.error("Failed to update status");
    }
  };

  const fetchCategories = async (page = 1) => {
    try {
      const url = search
        ? `${URLS.MASTERURL}?type=${10}&search=${search}`
        : `${URLS.MASTERURL}?type=${10}&page=${page}`;

      const res = await get(url);

      setList(res?.results || res?.data || []);
      setTotalCount(res?.count);
      // Assuming your API paginates with 10 items per page
      const pageSize = 10;
      const lastPage = Math.ceil(res?.count / pageSize);

      setPagination({
        current_page: page,
        last_page: lastPage,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCategore = async (id) => {
    try {
      const res = await get(`${URLS.MASTERURL}${id}/`);
      setAmenity(res?.data?.name);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCategories(page);
    if (editId) fetchCategore(editId);
  }, [page, search, editId]);

  const handleDelete = async () => {
    setPopup(false);
    setLoading(false);
    try {
      const res = await post(`${URLS.MASTERURL}${editId}/delete/`);
      console.log("res delete category", res);
      if (res?.status === "success") {
        toast.success(res?.message);
      }
      fetchCategories(page);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      toast.success("Delete Error please try again");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!amenity) {
      setErrors(true);
    } else {
      setErrors(false);
      setLoading(true);
      const formdata = new FormData();
      formdata.append("type", 10);
      formdata.append("name", amenity);

      if (type === "edit" && editId) {
        console.log("update edit");

        try {
          const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
          console.log("res edit room category", res);
          setAmenity("");
          if (res.status === "success") {
            toast.success("Edited successfully");
          }
          fetchCategories(page);
          setLoading(false);
        } catch (err) {
          console.error(err);
          setLoading(false);
        } finally {
          setLoading(false);
        }
      } else {
        try {
          setLoading(true);
          formdata.append("status", true);
          const res = await post(`${URLS.MASTERURL}add/`, formdata);
          console.log("res post room category", res);
          setAmenity("");
          fetchCategories(page);
          setLoading(false);
          if (res.status === "success") {
            toast.success(res.message || "Added successfully");
          }
        } catch (err) {
          console.error(err);
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
      setAddPopup(false); // or API call here
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: " Categories",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-ROOM_CATEGORIES"))
                    handleStatus(row.original);
                }}
                className={`${
                  value == false ? "deactive-btn" : "active-btn"
                } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value == false ? "De-active" : " Active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {checkPermission("CAN-EDIT-ROOM_CATEGORIES") && (
                  <button
                    onClick={() => {
                      setAddPopup(true);
                      setType("edit");
                      setEditId(row.original.id);
                      fetchCategore(row.original.id);
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-DELETE-ROOM_CATEGORIES") && (
                  <button
                    onClick={() => {
                      setPopup(true);
                      setEditId(row.original.id);
                    }}
                    // onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Topbar header={"Master"} subHead={"Room Categories"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total: {totalCount || list?.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
          {checkPermission("CAN-ADD-ROOM_CATEGORIES") && (
            <button
              onClick={() => {
                setAddPopup(true);
                setType("add");
              }}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add New
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type == "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setSelectedImage("");
                  setErrors("");
                  setAmenity("");
                }}
                className="pointer"
              />
            </div>
            <div className=" mt-4">
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                Categories
              </p>
              <input
                className="input-box w-100"
                name="userName"
                value={amenity}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/,/g, "");
                  setAmenity(sanitizedValue);
                }}
                type="text"
                placeholder=" Categories"
              />
              {errors && <p className="err text-start">Add Category</p>}
            </div>

            <div className="d-flex ac-jc px-2 mt-5">
              <button
                onClick={() => {
                  handleSubmit();
                  setPopup(false);
                  // logout();
                }}
                className="submit-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}{" "}
                {type == "add" ? "Add" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDelete} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default RoomCategories;
